/**
 * Anonymous/Guest user data - DEPRECATED
 * 
 * Guest authentication has been removed from the application.
 * Users must now sign up or sign in with valid credentials.
 * 
 * @deprecated Guest functionality has been removed
 */

const AnonymousUserData = {};

export default AnonymousUserData;
